import React, { Suspense, useEffect, useRef, useState } from "react";

const Cal = React.lazy(() => import("@calcom/embed-react"));

const loader = (
  <div className="flex min-h-[680px] flex-col items-center justify-center gap-4 text-center">
    <img src="/assets/revgengenius-mark-blue.png" alt="" aria-hidden="true" className="h-12 w-12 opacity-50" />
    <p className="text-sm font-medium text-[#5B6784]">Loading availability…</p>
  </div>
);

export default function CalInlineEmbed() {
  const hostRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "300px 0px", threshold: 0.01 }
    );
    observer.observe(host);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={hostRef}
      data-testid="cal-inline-embed"
      className="mt-8 min-h-[680px] w-full overflow-hidden rounded-[24px] border-[1.5px] border-[#D7E3FB] bg-white"
    >
      {visible ? (
        <Suspense fallback={loader}>
          <Cal
            calLink="adam-lightfield-yfl7s8/30min"
            namespace="contact-calendar"
            calOrigin="https://cal.com"
            style={{ width: "100%", height: "680px", overflow: "auto" }}
            config={{ theme: "light", useSlotsViewOnSmallScreen: "true" }}
          />
        </Suspense>
      ) : (
        loader
      )}
    </div>
  );
}
